// extracted by mini-css-extract-plugin
export var slide = "Slide-module--slide--b6fcb";
export var picture = "Slide-module--picture--8f282";
export var img = "Slide-module--img--194cf";